<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import Area from '../../../../shared/models/Area/Area';
	import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
	import Utente from '../../../../shared/models/Utente/Utente';
	import FieldLoading from './../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import { hasRoleSysAdmin } from '../../../../shared/stores';
	import ConfirmModal from '../../../../shared/components/common/Modal/ConfirmModal.svelte';

	export let params = {
		id: '0',
	};

	let openConfirmSendCredentialsToUser: boolean = false;
	let openConfirmSendCredentialsToAdmin: boolean = false;

	let sendCredentialsToUserLoading = false;
	let sendCredentialsToAdminLoading = false;

	let selectedArea, selectedAziendaEnte, selectedRole;

	let [data, loading, error] = Utente.get(params.id);
	let [dataRoles, loadingRoles, errorRoles] = Utente.getRolesList();
	let [dataAree, loadingAree, errorAree] = Area.getList();
	let [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ areaId: $data.area.id });

	$: selectedArea = $data.area;
	$: selectedAziendaEnte = $data.aziendaEnte;
	$: selectedRole = $data.role;

	$: if ($data.role == 'Area Manager') {
		if ($dataAree?.response && (!$data.area || $data.area?.id == 0)) {
			$data.area = $dataAree.response[0];
		}
		$data.aziendaEnte = new AziendaEnte();
	} else if ($data.role == 'Sys Admin') {
		$data.area = new Area();
		$data.aziendaEnte = new AziendaEnte();
	} else if (!$data.role || $data.role == '') {
		$data.area = new Area();
		$data.aziendaEnte = new AziendaEnte();
	}

	data.subscribe((value) => {
		if (value.area && value.area != selectedArea) {
			[dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ areaId: value.area.id });
		}
	});


    function onSendCredentialsToUser() {
		sendCredentialsToUserLoading = true;
		try {
			const [sendCredentialsToUserData, sendCredentialsToUserLoading, sendCredentialsToUserError] = Utente.sendCredentialsToUser($data.userId);
		} finally {
			sendCredentialsToUserLoading = false;
		}
	}

	function onSendCredentialsToAdmin() {
		sendCredentialsToAdminLoading = true;
		try {
			const [sendCredentialsToAdminData, sendCredentialsToAdminLoading, sendCredentialsToAdminError] = Utente.sendCredentialsToAdmin($data.userId);
		} finally {
			sendCredentialsToAdminLoading = false;
		}
    }

	function onSubmit() {
		[data, loading, error] = Utente.save($data);
	}
</script>

<ConfirmModal
    content="Questa operazione genererà una nuova password temporanea e la invierà via email. Continuare?"
	bind:showModal="{openConfirmSendCredentialsToUser}"
	onConfirm="{() => onSendCredentialsToUser()}"
/>
<ConfirmModal
    content="Questa operazione genererà una nuova password temporanea e la invierà via email agli amministratori. Continuare?"
	bind:showModal="{openConfirmSendCredentialsToAdmin}"
	onConfirm="{() => onSendCredentialsToAdmin()}"
/>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.user.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			{#if $data.editabile}
				<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
				</button>
			{/if}
			{#if $hasRoleSysAdmin && $data.userId && $data.email}
                <button 
                    on:click="{() => (openConfirmSendCredentialsToUser = true)}"
                    class="btn-white h-14 w-14 sm:h-16 sm:w-16"
                    disabled={sendCredentialsToUserLoading}
                    title="Invia nuove credenziali"
                >
                    {#if sendCredentialsToUserLoading}
                        <span class="material-icons-outlined animate-spin">refresh</span>
                    {:else}
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">
                            email
                        </span>
                    {/if}
                </button>
				<button 
                    on:click="{() => (openConfirmSendCredentialsToAdmin = true)}"
                    class="btn-white h-14 w-14 sm:h-16 sm:w-16"
                    disabled={sendCredentialsToAdminLoading}
                    title="Invia credenziali agli amministratori"
                >
                    {#if sendCredentialsToAdminLoading}
                        <span class="material-icons-outlined animate-spin">refresh</span>
                    {:else}
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">
                            admin_panel_settings
                        </span>
                    {/if}
                </button>
            {/if}
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input
				label="{$_('page.user.detail.user_name')}"
				bind:value="{$data.userName}"
				name="userName"
				disabled="{!$data.editabile}"
				class="md:col-start-2"
				required
			/>
			{#if $data.userId === ''}
				<Input type="password" label="Password" bind:value="{$data.password}" disabled="{!$data.editabile}" class="md:col-start-2" required/>
				<Input
					type="password"
					label="Conferma password"
					bind:value="{$data.confermaPassword}"
					disabled="{!$data.editabile}"
					class="md:col-start-2"
					required
				/>
				{#if $data.password !== $data.confermaPassword}
					<span class="md:col-start-2 text-xs leading-normal text-red-500">Le password non coincidono</span>
				{/if}
			{/if}
			<Input label="{$_('page.user.detail.name')}" bind:value="{$data.firstName}" disabled="{!$data.editabile}" class="md:col-start-2" />
			<Input label="{$_('page.user.detail.surname')}" bind:value="{$data.lastName}" disabled="{!$data.editabile}" class="md:col-start-2" />
			<Input label="{$_('page.user.detail.email')}" bind:value="{$data.email}" disabled="{!$data.editabile}" class="md:col-start-2" required/>
			<Input label="{$_('page.user.detail.telephone')}" bind:value="{$data.phoneNumber}" disabled="{!$data.editabile}" class="md:col-start-2" />
			{#if $loadingRoles}
				<FieldLoading customClass="md:col-start-2" />
			{:else if $dataRoles}
				<Select
					key="{(role) => `${role || ''}`}"
					label="{$_('page.user.detail.role')}"
					bind:value="{selectedRole}"
					class="md:col-start-2"
					disabled="{!$data.editabile}"
					required
				>
					{#each $dataRoles as role}
						{#if role}
							<Option
								value="{role}"
								on:click="{() => {
									$data.role = role;
								}}">{role}</Option
							>
						{/if}
					{/each}
				</Select>
			{/if}
			{#if $data.role && $data.role !== '' && $data.role !== 'Sys Admin'}
				{#if $loadingAree}
					<FieldLoading customClass="md:col-start-2" />
				{:else}
					<Select
						key="{(area) => `${(area && area.id) || ''}`}"
						label="{$_('page.user.detail.area')}"
						bind:value="{selectedArea}"
						class="md:col-start-2"
						disabled="{!$data.editabile}"
					>
						{#if $dataAree.response}
							{#each $dataAree.response as area (area.id)}
								{#if area.nomeComune}
									<Option
										value="{area}"
										on:click="{() => {
											$data.area = area;
											[dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ areaId: area.id });
										}}">{area.nomeComune}</Option
									>
								{/if}
							{/each}
						{/if}
					</Select>
				{/if}
				{#if $loadingAziendeEnti}
					<FieldLoading customClass="md:col-start-2" />
				{:else if $data.role !== 'Area Manager'}
					<Select
						key="{(aziendaEnte) => `${(aziendaEnte && aziendaEnte.id) || ''}`}"
						label="{$_('page.user.detail.company/entity')}"
						bind:value="{selectedAziendaEnte}"
						class="md:col-start-2"
						disabled="{!$data.editabile}"
					>
						{#if $dataAziendeEnti && $dataAziendeEnti.response}
							<Option value="{{}}" on:click="{() => ($data.aziendaEnte = new AziendaEnte())}" />
							{#each $dataAziendeEnti.response as aziendaEnte (aziendaEnte.id)}
								{#if aziendaEnte.nomeAziendaEnte}
									<Option value="{aziendaEnte}" on:click="{() => ($data.aziendaEnte = aziendaEnte)}">
										{aziendaEnte.nomeAziendaEnte}
									</Option>
								{/if}
							{/each}
						{/if}
					</Select>
				{/if}
			{/if}
		</form>
	{/if}
</Card>
